/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Choose_Folder_ButtonInputs */



/**
* | output |
* | --- |
* | "Choose Export Folder" |
*
* @param {Video_Export_Choose_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_choose_folder_button = /** @type {((inputs?: Video_Export_Choose_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Choose_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir le dossier d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli la cartella di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите папку экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar carpeta de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择导出文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートフォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a pasta de exportação")
	return /** @type {LocalizedString} */ ("Choose Export Folder")
});